import script from "./history.vue?vue&type=script&lang=ts&setup=true"
export * from "./history.vue?vue&type=script&lang=ts&setup=true"

import "./history.vue?vue&type=style&index=0&id=84367c58&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84367c58"]])

export default __exports__